export const currencies = [
  {
    name: 'BGN',
    value: 'BGN',
  },
  {
    name: 'BRL',
    value: 'BRL',
  },
  {
    name: 'CDF',
    value: 'CDF',
  },
  {
    name: 'ETB',
    value: 'ETB',
  },
  {
    name: 'EUR',
    value: 'EUR',
  },
  {
    name: 'GBP',
    value: 'GBP',
  },
  {
    name: 'GHS',
    value: 'GHS',
  },
  {
    name: 'INR',
    value: 'INR',
  },
  {
    name: 'KES',
    value: 'KES',
  },
  {
    name: 'MMK',
    value: 'MMK',
  },
  {
    name: 'MZN',
    value: 'MZN',
  },
  {
    name: 'NGN',
    value: 'NGN',
  },
  {
    name: 'RUB',
    value: 'RUB',
  },
  {
    name: 'SEK',
    value: 'SEK',
  },
  {
    name: 'TZS',
    value: 'TZS',
  },
  {
    name: 'USD',
    value: 'USD',
  },
  {
    name: 'ZMK',
    value: 'ZMK',
  },
  {
    name: 'CHF',
    value: 'CHF',
  },
];
